import { Card, ChartContainer, ChartTooltip, ChartTooltipContent } from "@repo/ui";
import { Protected, useAuthenticatedFetch } from "@stardeck-customer-apps/project-auth";
import { useEffect, useState } from "react";
import { Bar, BarChart, Pie, PieChart, ResponsiveContainer, XAxis, YAxis } from "recharts";

export default function ReportsPage() {
  return (
    <Protected redirectTo="/login">
      <Content />
    </Protected>
  );
}

function Content() {
  const authFetch = useAuthenticatedFetch();
  type SummaryRow = { stage: string; source?: string; count: number; total_cents: number };
  const [data, setData] = useState<{ bySource: SummaryRow[]; byStage: SummaryRow[] } | null>(null);

  useEffect(() => {
    (async () => {
      const res = await authFetch("/api/reports/summary");
      setData((await res.json()) as { bySource: SummaryRow[]; byStage: SummaryRow[] });
    })();
  }, [authFetch]);

  const leadsBySource = (data?.bySource ?? []).map((d) => ({
    label: d.source || "unknown",
    value: Number(d.count || 0),
  }));
  const revenueByStage = (data?.byStage ?? []).map((d) => ({
    label: d.stage || "",
    value: Number(d.total_cents || 0) / 100,
  }));

  return (
    <div className="p-6 space-y-6">
      <Card className="p-4 space-y-4">
        <h3 className="font-semibold">Leads by Source</h3>
        <ChartContainer config={{ value: { label: "Leads" } }}>
          <ResponsiveContainer width="100%" height={260}>
            <PieChart>
              <Pie data={leadsBySource} dataKey="value" nameKey="label" fill="var(--primary)" />
              <ChartTooltip content={<ChartTooltipContent />} />
            </PieChart>
          </ResponsiveContainer>
        </ChartContainer>
      </Card>
      <Card className="p-4 space-y-4">
        <h3 className="font-semibold">Revenue by Stage</h3>
        <ChartContainer config={{ value: { label: "Revenue" } }}>
          <ResponsiveContainer width="100%" height={260}>
            <BarChart data={revenueByStage}>
              <XAxis dataKey="label" hide />
              <YAxis hide />
              <Bar dataKey="value" fill="var(--primary)" radius={[4, 4, 0, 0]} />
              <ChartTooltip content={<ChartTooltipContent />} />
            </BarChart>
          </ResponsiveContainer>
        </ChartContainer>
      </Card>
    </div>
  );
}
